var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.28 100.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ff441d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 100.28,
    height: 100.28,
    rx: 15.82,
    ry: 15.82
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.65 35.33 75.63 23.33 26.46 23.33 26.48 35.42 44.56 35.39 44.56 84.33 57.56 84.33 57.56 35.36 75.65 35.33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateLogo);
export default __webpack_public_path__ + "static/media/template_logo.4882c4ee9f01d59ba2870b30e4988ecc.svg";
export { ForwardRef as ReactComponent };